import React, { useState, useEffect } from 'react'

import {
    makeStyles,
    Theme,
    Paper,
    List,
    ListItem,
    ListItemText,
    Checkbox,
    Typography,
    Button,
    Box,
} from '@material-ui/core'

import { FacilityConfig } from '../../hooks/useFacilitiesPlan/types'
import { AreaConfig } from '../../models/Config/types'

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        padding: theme.spacing(2),
        minWidth: 300,
        maxWidth: 400,
    },
    list: {
        maxHeight: 300,
        overflowY: 'auto',
    },
    footer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
}))

interface InventorySelectorProps {
    selectedFacility: FacilityConfig
    areaConfig: AreaConfig
    onSelectionChange: (selectedIds: number[]) => void
    onClose: () => void
}

export const InventorySelector: React.FC<InventorySelectorProps> = ({
    selectedFacility,
    areaConfig,
    onSelectionChange,
    onClose,
}) => {
    const classes = useStyles()
    const inventoryItems =
        selectedFacility.inspectionType?.inventory_configs || []

    // Get selected IDs for this area config
    const selectedAreaConfig = selectedFacility.areaConfigs.find(
        (ac) => ac.area_config_id === areaConfig.id,
    )
    const [selectedIds, setSelectedIds] = useState<number[]>(
        selectedAreaConfig?.inventory_config_ids || [],
    )

    // Update selectedIds when selectedFacility or areaConfig changes
    useEffect(() => {
        const selectedAreaConfig = selectedFacility.areaConfigs.find(
            (ac) => ac.area_config_id === areaConfig.id,
        )
        setSelectedIds(selectedAreaConfig?.inventory_config_ids || [])
    }, [selectedFacility, areaConfig])

    const handleToggle = (id: number) => {
        const newSelectedIds = selectedIds.includes(id)
            ? selectedIds.filter((selectedId) => selectedId !== id)
            : [...selectedIds, id]
        setSelectedIds(newSelectedIds)
    }

    return (
        <Paper className={classes.paper}>
            <Typography variant="h6" className={classes.title}>
                Select Light Inventory Items
            </Typography>
            <List className={classes.list}>
                {inventoryItems.map((item) => (
                    <ListItem
                        key={item.id}
                        dense
                        button
                        onClick={() => handleToggle(item.id)}
                    >
                        <Checkbox
                            edge="start"
                            checked={selectedIds.includes(item.id)}
                            tabIndex={-1}
                            disableRipple
                        />
                        <ListItemText
                            primary={item.name}
                            secondary={item.description}
                        />
                    </ListItem>
                ))}
            </List>
            <Box className={classes.footer}>
                <Button
                    onClick={() => {
                        onSelectionChange(selectedIds)
                        onClose()
                    }}
                    color="primary"
                >
                    Done
                </Button>
            </Box>
        </Paper>
    )
}
